import getParamsFromString from "./getParamsFromString"
import resolveURL from "./resolveURL"
import appendHashParamsToURL from "./appendHashParamsToURL"

export default (url, baseURL, hash) => {
  return appendHashParamsToURL(getParamsFromString(hash), resolveURL(url, baseURL)).toString()
}
